import { put, takeEvery, call, select } from 'redux-saga/effects';
import { VettingActions } from './actions';
import ApiService from '../../../Services/ApiService';
import { AppActions } from '../app/actions';
import { displayNotification, history, getUseCaseTextFromKey } from '../../../Utils/GenericUtils';
import { VettingSelectors } from './selectors';

export function* submitVetting(action) {
  try {
    const payloadParams = action.payload;
    const reducerParams = yield select(VettingSelectors.vettingFieldsSelector);
    const { email } = payloadParams;
    const params = {
      first_name: reducerParams.firstName,
      last_name: reducerParams.lastName,
      agree_to_terms: reducerParams.agreeToTerms,
      email: reducerParams.email,
      company: reducerParams.company,
      phone: reducerParams.phone,
      country: payloadParams.country || null,
      product: reducerParams.product || payloadParams.product,
      recaptcha: reducerParams.captcha,
      use_case_code: reducerParams.useCaseCode,
      seats_number: 1,
      team_size: reducerParams.teamSize,
      industry: reducerParams.industry,
      industry_other: reducerParams.otherIndustryDescription || null,
      job: reducerParams.job,
      use_case_category_text: getUseCaseTextFromKey(reducerParams.useCaseText) || null,
      use_case_sub_category_text: reducerParams.otherDescription,
      custom_use_case: null,
      use_case_category_text_key: reducerParams.useCaseText,
      use_case_sub_category_text_key:
        reducerParams.otherDescription?.length > 1 ? reducerParams.otherDescription : null,
      website: payloadParams.website || null,
      description: payloadParams.description || null,
    };

    const emailUrlPath = yield call(ApiService.generateLink, 'email-confirm/');
    yield call(ApiService.leadVetting, { params });
    yield put(AppActions.setOnBoardingEmailConfirm(email));
    yield put(VettingActions.submitVettingSucceeded());
    history.push(`${emailUrlPath}`);
    window.location.reload();
  } catch (e) {
    const data = e?.response?.data;
    if (data?.status === 'RED') {
      const blockPath = yield call(ApiService.generateLink, 'block/');
      yield put(VettingActions.submitVettingSucceeded());
      yield put(AppActions.setOnBoardingBlockReason(data.reason));
      history.push(`${blockPath}`);
      window.location.reload();
    } else if (data.reason === 'more_info_required') {
      yield put(VettingActions.submitVettingSucceeded());
      yield put(VettingActions.getMoreInfo());
    } else if (e.response.data === 'Failed captcha validation') {
      yield put(VettingActions.submitVettingFailed(data));
      displayNotification(
        'error',
        'Error',
        'Your session is expired, please refresh the page and fill your sign-up form again',
      );
    } else {
      console.log(e);
      yield put(VettingActions.submitVettingFailed(data));
      displayNotification(
        'error',
        'Error',
        'There was an error while processing your sign up request. Please try again later.',
      );
    }
  }
}

export function* resendConfirmationEmail(action) {
  try {
    const res = yield call(ApiService.resendConfirmationEmail, action.payload);
    yield put(VettingActions.resendConfirmationEmailSucceeded(res));
    displayNotification('success', 'Success', 'Email was resent, please check your inbox!');
  } catch (e) {
    yield put(VettingActions.resendConfirmationEmailFailed());
    if (e.response.data === 'Please wait 10 minutes before resending email again')
      displayNotification('error', 'Error', 'Please wait 10 minutes before resending email');
  }
}

export function* watchVetting() {
  yield takeEvery(VettingActions.submitVettingStep3, submitVetting);
  yield takeEvery(VettingActions.submitVetting, submitVetting);
  yield takeEvery(VettingActions.resendConfirmationEmail, resendConfirmationEmail);
}
